module.exports = __webpack_public_path__ + "static/media/pt5.964ab69d.jpg";